import { Component, EventEmitter, Input, Output } from '@angular/core'

@Component({
    selector: 'eb-load-more-button',
    templateUrl: './eb-load-more-button.component.html',
    styleUrls: ['./eb-load-more-button.component.scss'],
    standalone: false
})
export class EbLoadMoreButtonComponent {
  @Input() loading = false
  @Output() clicked = new EventEmitter()
}
